import { useState } from "react";
import { Box } from "@mui/material";
import ArrowUpSLineIcon from "remixicon-react/ArrowUpSLineIcon";
import ArrowDownSLineIcon from "remixicon-react/ArrowDownSLineIcon";
import Addicon from "@mui/icons-material/Add";
import { Button, Modal, Text } from "$components";
import useJStyles from "$hooks/useJStyles";
import { MISSING_SHIPPING_ADDRESS, MISSING_SHIPPING_REF } from "../constants";

export const CellExpander = ({ row, handleOpenDrawer, disabled }: any) => {
  const [recordCreationError, setRecordCreationError] = useState("");
  const { jclasses } = useJStyles();
  return (
    <Box
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <span
        {...row.getToggleRowExpandedProps()}
        style={{
          minWidth: 30,
          padding: 3,
          marginLeft: 4,
          position: "relative",
          top: 2,
        }}
      >
        {row.isExpanded ? (
          <ArrowUpSLineIcon
            color={row.original.disabled ? "#B3BAC5" : "default"}
          />
        ) : (
          <ArrowDownSLineIcon
            color={row.original.disabled ? "#B3BAC5" : "default"}
          />
        )}
      </span>
      <Button
        variant="text"
        sx={{
          minWidth: 50,
          padding: 1,
          border: "none !important",
          outline: "none !important",
          color: "black !important",
          backgroundColor: "transparent !important",
          boxShadow: "none !important",
          "&:hover": {
            backgroundColor: "transparent !important",
            boxShadow: "none !important",
            border: "none !important",
            outline: "none !important",
            color: "black !important",
          },
          "&:focus": {
            backgroundColor: "transparent !important",
            boxShadow: "none !important",
            border: "none !important",
            outline: "none !important",
            color: "black !important",
          },
          "&:active": {
            backgroundColor: "transparent !important",
            boxShadow: "none !important",
            border: "none !important",
            outline: "none !important",
            color: "black !important",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent !important",
            color: "black !important",
          },
          "& svg": {
            fontSize: 18,
            color: "black !important",
          },
        }}
        disabled={disabled}
        onClick={() => {
          if (!row.original?.refPreparationEntrepot) {
            setRecordCreationError(MISSING_SHIPPING_REF);
          } else if (!row.original?.shipAdress) {
            setRecordCreationError(MISSING_SHIPPING_ADDRESS);
          } else {
            handleOpenDrawer(row.original);
          }
        }}
      >
        <Addicon />
      </Button>

      <Modal
        title="Impossible de créer le dossier"
        textValidate="OK"
        open={recordCreationError !== ""}
        onValidate={() => setRecordCreationError("")}
        onCancel={() => setRecordCreationError("")}
        noCancelButton
      >
        <Box className={jclasses.dialogContent} style={{ textAlign: "center" }}>
          <Text>
            {recordCreationError}
            <br />
            Veuillez revoir la sélection afin de créer le dossier
          </Text>
        </Box>
      </Modal>
    </Box>
  );
};
